import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=0f20c651&"
import script from "./form.js?vue&type=script&lang=js&"
export * from "./form.js?vue&type=script&lang=js&"
import style0 from "./form.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports